module.exports = __webpack_public_path__ + "img/paytype-top-hen.c3d8b646.png";